import { render, staticRenderFns } from "./myCourseEnclosure.vue?vue&type=template&id=5136ef09&scoped=true&"
import script from "./myCourseEnclosure.vue?vue&type=script&lang=js&"
export * from "./myCourseEnclosure.vue?vue&type=script&lang=js&"
import style0 from "./myCourseEnclosure.vue?vue&type=style&index=0&id=5136ef09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136ef09",
  null
  
)

export default component.exports